function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg403({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177.333 104.667",
    style: {
      enableBackground: "new 0 0 177.333 104.667"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    style: {
      fill: "#205081",
      stroke: "#205081",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "8,15"
    },
    d: " M158.901,82.896H17.766c-4.782,0-8.659-3.877-8.659-8.659V36.429c0-4.782,3.877-8.659,8.659-8.659h141.135 c4.782,0,8.659,3.877,8.659,8.659v37.809C167.559,79.02,163.683,82.896,158.901,82.896z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_57_",
    x: 18.127,
    y: 38.954,
    style: {
      opacity: 0.2,
      fill: "#205081"
    },
    width: 7.95,
    height: 33.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    style: {
      fill: "#F4F5F5",
      stroke: "#1F5180",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "8,15"
    },
    d: " M158.901,80.896H17.766c-4.782,0-8.659-3.877-8.659-8.659V34.429c0-4.782,3.877-8.659,8.659-8.659h141.135 c4.782,0,8.659,3.877,8.659,8.659v37.809C167.559,77.02,163.683,80.896,158.901,80.896z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_50_",
    x: 18.127,
    y: 36.954,
    style: {
      opacity: 0.2,
      fill: "#1F5180"
    },
    width: 7.95,
    height: 33.48
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.742,
    y: 45.2,
    style: {
      opacity: 0.2,
      fill: "#1F5180"
    },
    width: 99.92,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.742,
    y: 57.466,
    style: {
      opacity: 0.2,
      fill: "#1F5180"
    },
    width: 72.875,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.a96ee5eacc97c2fe2244a81efdc859d4.svg";
export { ForwardRef as ReactComponent };